import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import YearlyFeeCollectionYears from '@/components/yearly-fee-collection/years'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'

function FeeCollectionView() {

    const title = 'Výběr ročního poplatku'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                <MunicipalityPermissionGate>
                    <YearlyFeeCollectionYears />
                </MunicipalityPermissionGate>
            </CustomPaper>
        </>
    )
}

export default FeeCollectionView
